import { boxList } from './boxes'

export const getNextQuestionSetForWorkout = ({ questions, responses, numQuestions }) => {
  // TODO: crazy algorithm based on previous responses and which box they are in
  // for now we just return 10 random questions
  let questionCount = 0
  let allQuestionsArray = []
  Object.keys(questions).forEach(id => {
    allQuestionsArray.push({
      id,
      ...questions[id],
    })
  })
  const nextQuestions = []
  while (questionCount < numQuestions) {
    questionCount += 1
    let randomIndex = Math.floor(Math.random() * allQuestionsArray.length)
    nextQuestions.push(allQuestionsArray[randomIndex])
    allQuestionsArray.splice(randomIndex, 1)
  }
  return nextQuestions
}

export const getBoxSplit = ({ boxSpread }) => {
  const boxSplit = []
  boxList.forEach(box => {
    const achieved = boxSpread[box.id] || 0
    boxSplit.push({ achieved, achievedColor: box.color })
  })
  return boxSplit
}



// WEBPACK FOOTER //
// ./src/module/utils.js